import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ScaleText from "react-scale-text";
import { selectGameId } from "features/gamestate/gameStateSlice";
import Analytics from "analytics";
import { EVENTS } from "analytics/events";
import {
  selectCategory,
  selectPanelMode,
  selectSelectedCategoryIdx,
} from "./editorSlice";
import "./roundEditor.css";

const EditorCategoryCell = ({
  label,
  categoryIdx,
  round,
  clueCount = 0,
  maxFont = 22,
}) => {
  const dispatch = useDispatch();
  const panelMode = useSelector(selectPanelMode);
  const selectedCategoryIdx = useSelector(selectSelectedCategoryIdx);
  const gameId = useSelector(selectGameId);
  const isSelected =
    panelMode === "category" && selectedCategoryIdx === categoryIdx;

  const handleClick = () => {
    const opening = !(
      panelMode === "category" && selectedCategoryIdx === categoryIdx
    );
    dispatch(selectCategory({ categoryIdx }));
    if (opening) {
      Analytics.track(EVENTS.CATEGORY_RENAME_OPENED, {
        game_id: gameId,
        round,
        category_idx: categoryIdx,
        clue_count: clueCount,
      });
    }
  };

  return (
    <div
      className={`re-cat-cell ${isSelected ? "is-selected" : ""}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleClick()}
      aria-pressed={isSelected}
      title={label}
    >
      <ScaleText minFontSize={9} maxFontSize={maxFont}>
        <span className="re-cat-label">{label || "—"}</span>
      </ScaleText>
      <span className="re-cat-edit-icon" aria-hidden="true">
        ✎
      </span>
    </div>
  );
};

export default EditorCategoryCell;
